"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Archive Admin API
 * Archive Admin API for managing channels retrieving them from the database. This API allows you to interact with the archived_channels database.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse200ToJSON =
  exports.InlineResponse200FromJSONTyped =
  exports.InlineResponse200FromJSON =
    void 0;
var runtime_1 = require("../runtime");
function InlineResponse200FromJSON(json) {
  return InlineResponse200FromJSONTyped(json, false);
}
exports.InlineResponse200FromJSON = InlineResponse200FromJSON;
function InlineResponse200FromJSONTyped(json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    status: !runtime_1.exists(json, "status") ? undefined : json["status"],
  };
}
exports.InlineResponse200FromJSONTyped = InlineResponse200FromJSONTyped;
function InlineResponse200ToJSON(value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    status: value.status,
  };
}
exports.InlineResponse200ToJSON = InlineResponse200ToJSON;
